import { Link } from "react-router-dom";

const Logo = ({ large = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-3" aria-label="MVALOG Int. Transport Co. Ltd. — From Good to Great">
    <img
      src="/logo.png"
      alt="MVALOG"
      data-testid="logo-image"
      className={`w-auto shrink-0 ${large ? "h-24 lg:h-28" : "h-12 md:h-14"}`}
    />
    <span className="leading-none">
      <span className={`block font-brand font-semibold text-brand tracking-[0.08em] ${large ? "text-4xl" : "text-xl md:text-2xl"}`}>
        MVALOG
      </span>
      <span className={`block font-brand uppercase text-brand/80 ${large ? "text-sm tracking-[0.35em] mt-3" : "text-[8px] md:text-[9px] tracking-[0.28em] mt-1.5"}`}>
        From Good to Great
      </span>
    </span>
  </Link>
);

export default Logo;
